import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvestorAllocatedLoansComponent } from './investor-allocated-loans/investor-allocated-loans.component';
import {InvestormenuModule} from '../../../investormenu/investormenu.module';
import {HorizontalLoaderModule} from '../../../horizontal-loader/horizontal-loader.module';
import {InvestorLoansRoutingModule} from './investor-loans.routing.module';
import {CommonSectionsModule} from '../../common/common-sections.module';
import {MatPaginatorModule, MatProgressSpinnerModule, MatTableModule} from '@angular/material';
import {IndianCurrencyFormatterModule} from '../../common/indian-currency-formatter/indian-currency-formatter.module';


@NgModule({
  declarations: [InvestorAllocatedLoansComponent],
    imports: [
        InvestorLoansRoutingModule,
        HorizontalLoaderModule,
        CommonModule,
        CommonSectionsModule,
        InvestormenuModule,
        MatProgressSpinnerModule,
        MatTableModule,
        IndianCurrencyFormatterModule,
        MatPaginatorModule
    ]
})
export class InvestorLoansModule { }
